export default __webpack_public_path__ + "static/media/download-file-icon.ecb91be8.svg";